import { createSignal, createRoot } from 'solid-js';

function createInviteCodeState() {
  const [globalInviteCode, setGlobalInviteCode] = createSignal<string>('');

  const clearGlobalInviteCode = () => {
    setGlobalInviteCode('');
  };

  return {
    globalInviteCode,
    setGlobalInviteCode,
    clearGlobalInviteCode,
  };
}
export const useInviteCodeStore = createRoot(createInviteCodeState);
